import { Phone } from "lucide-react";
import { BRAND } from "@/lib/brand";

export default function StickyCallButton() {
  return (
    <a
      href={BRAND.phoneHref}
      data-testid="sticky-call-button"
      className="fixed bottom-6 right-6 z-40 group"
      aria-label={`Call ${BRAND.phone}`}
    >
      <span className="absolute inset-0 rounded-full bg-[#00A65A] animate-ping opacity-50" />
      <span className="relative flex items-center gap-2 bg-[#00A65A] text-white pl-4 pr-5 py-3.5 rounded-full shadow-2xl hover:bg-[#0B1B3D] transition-colors">
        <Phone className="w-5 h-5" />
        <span className="hidden sm:inline font-medium text-sm">Call Now</span>
      </span>
    </a>
  );
}
